$(function () {
var width = $(window).width();
if( width < 840 ){
    $(".switch-img").each(function(){
        $(this).attr("src", $(this).attr("src").replace("_pc","_sp"));
    })
}
});

$(function(){
  $('a[href^=#]').click(function() {
  var speed = 500;
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top;
  $('html').animate({scrollTop:position}, speed, 'swing');
  return false;
  });
});

$(function(){
  var imgHeight = $('#mv').outerHeight(); 
  var header = $('.header'); 
  $(window).on('load scroll', function(){
     if ($(window).scrollTop() < imgHeight) {
       header.removeClass('headerColor-default');
     }else {
       header.addClass('headerColor-default');
     }
  });
});

$('.mvSlider').slick({
    fade:true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed:1000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
});


$(function () {
  $(".hamburgerMenu").click(function () {
    if ($(this).hasClass("active")) {
      $("html, body").removeClass("fixed"); 
    } else {
      $("html, bofy").addClass("fixed");
    }
    $(".hamburgerMenu").toggleClass("active");
  });
});

$(function () {
  $(window).scroll(function () {
    const windowHeight = $(window).height();
    const scroll = $(window).scrollTop();
    $('.js-fadeIn').each(function () {
      const targetPosition = $(this).offset().top;
      if (scroll > targetPosition - windowHeight + 100) {
        $(this).addClass("is-scrollIn");
      }
    });
  });
});